import { Component, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AuthService, LoginViewModel, AuditLog, UserSessionService } from '../shared';
import { ToastService } from '../blocks';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { UserService } from '../security/userData';
import { DOCUMENT } from '@angular/common';


@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class Login {
    //loginModel: LoginViewModel = { userName: 'admin', password: '' };
    //loginModel: LoginViewModel = { userName: 'mohamed', password: '123456' };
    loginModel: LoginViewModel = <LoginViewModel>{};
    public errorMsg = '';
    authResult: boolean = true;
    displayFlag: any;
    StyleFlag: any;
    dispalySetting: any;
    StyleSetting: any;
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    auditLog: AuditLog = <AuditLog>{};
    editUser: any;
    branchId: number
    // i.hamed customizaton background
    showMessage: boolean = true;

    constructor(private _authService: AuthService,
        public translate: TranslateService,
        private _router: Router,
        private _userService: UserSessionService,
        private _userDataService: UserService,
        private _toastService: ToastService,
        @Inject(DOCUMENT) private document
    ) { }


    // auditsTransUserLogLogin(){
    //     this.auditLog.TransType = 1
    //     this._authService.auditsTransUserLogSave(this.auditLog).pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe(c => {});
    // }
    authMsg: any;
    login() {
        if ((this.loginModel.userName == undefined || this.loginModel.userName == null || !this.loginModel.userName.replace(/\s/g, '').length) ||
            (this.loginModel.password == undefined || this.loginModel.password == null || !this.loginModel.password.replace(/\s/g, '').length)) {
            this._toastService.activateMsg('WARNINGUSERNAMEPASSWORD');
            return;
        }



        this._authService.login(this.loginModel).subscribe(
            u => {
                // if(u) {
                this.authResult = u;
                //     this.authMsg = u;
                // } else {
                //     this.authResult = false;
                // }
            },
            error => { },
            () => {
                this.errorMsg = '';
                let tempUser = JSON.parse(sessionStorage.getItem('currentUser'));
                let loginErrors = JSON.parse(sessionStorage.getItem('loginErrors'));
                // this._userService.secLoginId = tempUser && tempUser.secLoginId ? tempUser.secLoginId : null
                this._userService.setSessionKey('secUserMainData', tempUser)

                if (this.authResult) {
                    this.showMessage = true;
                    this.getUserData(tempUser['userID']);
                    if (tempUser['defaultLang'] == 1) {
                        this.translate.use('en')
                        this.document.getElementById('ltrCssFile').setAttribute('href', 'assets/css/ltr.css');
                    }
                    else if (tempUser['defaultLang'] == 2) {
                        this.translate.use('ar')
                        this.document.getElementById('ltrCssFile').setAttribute('href', 'assets/css/rtl.css');
                    }
                } else {
                    // this.errorMsg = "اسم المستخدم او كلمة المرور غير صحيح";
                    if (loginErrors.messageCode == -100) {
                        this.errorMsg = "اسم المستخدم غير صحيح";
                    } else if (loginErrors.messageCode == -101) {
                        this.errorMsg = "كلمة المرور غير صحيحة";
                    } else if (loginErrors.messageCode == -102) {
                        this.errorMsg = "هذا المستخدم غير فعال";
                    }
                    this.showMessage = false;
                }
            });
        this.getStyleImg();
    }
    getUserData(userId: any) {
        this._userDataService.getUser(userId).subscribe(
            user => {
                if (user.data.length > 0 && user.data[0]) {
                    this._userService.setSessionKey('GetUserData', user.data[0])
                }
                this.editUser = user.data[0];
                if (this.editUser['defaultLang'] == 1) {
                    this.translate.use('en')
                    this.document.getElementById('ltrCssFile').setAttribute('href', 'assets/css/ltr.css');
                }
                else if (this.editUser['defaultLang'] == 2) {
                    this.translate.use('ar')
                    this.document.getElementById('ltrCssFile').setAttribute('href', 'assets/css/rtl.css');
                }
                if (this.editUser['routePath']) {
                    this._router.navigateByUrl(this.editUser['routePath']);
                    this._userService.setSessionKey('ROUTEPATH', this.editUser['routePath']);
                } else {
                    this._router.navigateByUrl('/dashboard');
                }
            });
    }

    Blure() { }

    @HostListener('document:keydown', ['$event'])
    hotkeys(event) {
        let text = event.key;
        if (text == 'Enter') {
            this.login();
            event.preventDefault();
        }
    }

    ngOnInit() {
        this._authService.getJSON().subscribe(data => {
            this.dispalySetting = data.DisplaySetting;
            this.displayFlag = this.dispalySetting.DisplayFlag;
            this.StyleSetting = data.StyleSetting;
            this.StyleFlag = this.StyleSetting.StyleFlag;
            this._userService.displayFlag = this.displayFlag
            this._userService.styleFlag = this.StyleFlag
        });

      //  this.branchId = this.getBranchId()
    }
    // getBranchId(): number {
    //     let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    //     return currentUser && currentUser.userID ? +currentUser.branchId : 0;
    // }

    getBackgroundImg() {
        switch (this.displayFlag) {
            case 1:
                return 'loginbg';
            case 2:
                return 'loginbg-erp';
            case 3:
                return 'loginbg-hr';
            case 4:
                return 'loginbg-clinic';
            case 5:
                return 'loginbg-selat';
            default:
                return 'loginbg';
        }
    }

    getStyleImg() {
        switch (this.StyleFlag) {
            case 1:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-1.css');
                break;
            case 2:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-2.css');
                break;
            case 3:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-3.css');
                break;
            case 4:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-4.css');
                break;
            case 5:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-5.css');
                break;
            case 6:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-6.css');
                break;
            default:
                this.document
                    .getElementById('LoginStyleFlag')
                    .setAttribute('href', 'assets/css/homepage-design-1.css');
        }
    }



}


function GetComputerName() {
    try {
        //var network = new ActiveXObject('WScript.Network');
        // Show a pop up if it works
        //alert(network.computerName);
    }
    catch (e) { }
}
